'use client';
import { APIProvider, Map, Marker } from '@vis.gl/react-google-maps';
import { OpenInNewWindowIcon } from '@radix-ui/react-icons';
import { IPropertyDetails } from '@/app/actions/serverActions';
import PropertyBreadcrumbs from '@/components/elements/Properties/PropertyDetails/BreadCrumbs';

export default function PropertyLocation({
  location,
  destination,
  area,
  lng,
  lat,
}: {
  destination: IPropertyDetails['destination'];
  area: IPropertyDetails['area'];
  location?: IPropertyDetails['location'];
  lng: IPropertyDetails['pin']['lat'];
  lat: IPropertyDetails['pin']['lat'];
}) {
  const API_KEY = process.env.NEXT_PUBLIC_GOOGLE_MAP_API_KEY as string;

  const handleMarkerClick = () => {
    // Construct Google Maps URL
    const googleMapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

    // Open the Google Maps app or browser
    window.open(googleMapsUrl, '_blank');
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="text-xl font-milligram font-bold uppercase">The Location</div>
      <div className="text-base flex flex-col gap-2">
        <PropertyBreadcrumbs destination={destination} area={area} />
        <div className="text-sm">{location}</div>
      </div>

      <APIProvider apiKey={API_KEY}>
        <div className="mb-16 w-full h-96 relative">
          <Map
            className="my-8 w-full h-96"
            defaultZoom={12}
            defaultCenter={{
              lat,
              lng,
            }}
            gestureHandling={'greedy'}
            disableDefaultUI={true}
          >
            <div
              className="absolute top-0 left-0 p-2 bg-white z-10 text-sm flex gap-2 cursor-pointer"
              onClick={() => handleMarkerClick()}
            >
              View in Maps
              <OpenInNewWindowIcon />
            </div>
            <Marker
              position={{
                lat,
                lng,
              }}
            />
          </Map>
        </div>
      </APIProvider>
    </div>
  );
}
